<template>
  <b-card id="page-agenda-partial" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-center"
    >
      <b-col cols="12" md="4">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >
      </b-col>
      <b-col cols="12" md="8" class="d-none d-md-table">
        <b-col cols="12" class="d-flex align-items-between justify-content-end">
          <b-button
            variant="outline-primary"
            class="mr-1"
            :disabled="loading || refreshing"
            @click="refreshAgendaPartials(true)"
          >
            <b-spinner v-if="refreshing" small class="mr-25" />
            <feather-icon
              v-else
              icon="RefreshCwIcon"
              class="mr-25"
              size="18"
            />
            <span class="text-nowrap">
              {{ $t(label(refreshing ? "refreshing" : "refresh")) }}
            </span>
          </b-button>
          <b-button
            v-if="canCreate"
            id="tooltip-create"
            variant="primary"
            @click="onCreate"
          >
            <feather-icon
              aria-label="Register"
              icon="PlusIcon"
              class="mr-25"
              size="18"
            />
            <span class="text-nowrap">{{ $t(label("register")) }}</span>
          </b-button>
        </b-col>
      </b-col>
      <b-col
        cols="12"
        sm="12"
        md="8"
        class="d-md-none d-flex justify-content-end pt-2"
      >
        <b-button
          variant="outline-primary"
          class="btn-icon mr-1"
          :disabled="loading || refreshing"
          :aria-label="$t(label('refresh'))"
          @click="refreshAgendaPartials(true)"
        >
          <b-spinner v-if="refreshing" small />
          <feather-icon v-else icon="RefreshCwIcon" size="18" />
        </b-button>
        <b-button
          v-if="canCreate"
          id="tooltip-create"
          variant="primary"
          @click="onCreate"
          class="btn-icon"
        >
          <feather-icon icon="PlusIcon" size="18" aria-label="Register" />
        </b-button>
      </b-col>
      <b-tooltip
        v-if="canCreate"
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>
    <Filterss
      :fields="fildsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />
    <!-- Table for larger devices -->
    <div class="agenda-partial-table-shell d-none d-md-block">
      <b-table
        id="agenda-partial-table"
        responsive
        table-class="agenda-partial-data-table"
        :head-variant="headVariant"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :per-page="perPage"
        :busy="loading"
        :items="items"
        :fields="fields"
        class="shadow-sm rounded"
      >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(nameClient)="data">
        <slot name="cell-nameClient" :data="data">
          {{ data.item.nameClient || "N/A" }}
        </slot>
      </template>

      <template #cell(urlWhatsApp)="data">
        <slot name="cell-urlWhatsApp" :data="data">
          {{ formatWhatsAppPhone(data.item.urlWhatsApp) }}
        </slot>
      </template>

      <template #cell(nameEmployee)="data">
        <slot name="cell-nameEmployee" :data="data">
          {{ data.item.nameEmployee || "N/A" }}
        </slot>
      </template>

      <template #cell(nameService)="data">
        <slot name="cell-nameService" :data="data">
          {{ data.item.nameService || "N/A" }}
        </slot>
      </template>

      <template #cell(dateCreation)="data">
        <slot name="cell-dateCreation" :data="data">
          {{ formatDateTime(data.item.dateCreation) }}
        </slot>
      </template>

      <template #cell(appointmentDate)="data">
        <slot name="cell-appointmentDate" :data="data">
          {{ formatDate(data.item.appointmentDate) }}
        </slot>
      </template>

      <template #cell(idCatStatus)="data">
        <slot name="cell-idCatStatus" :data="data">
          <v-select
            class="agenda-partial-status-select"
            :value="data.item.idCatStatus"
            :options="listStatus"
            label="label"
            :reduce="(option) => option.value"
            :clearable="false"
            :filterable="false"
            :disabled="changingStatusId === data.item.idAgendaPartial"
            @input="changeAgendaPartialStatus(data.item, $event)"
          >
            <span slot="no-options">{{ $t("sorryOption") }}</span>
          </v-select>
        </slot>
      </template>

      <template #cell(notes)="data">
        <div class="agenda-partial-note">
          {{ data.item.notes || "N/A" }}
        </div>
      </template>

      <template #cell(actions)="data">
        <div class="agenda-partial-actions">
          <feather-icon
            class="text-success cursor-pointer"
            aria-label="Show details"
            size="18"
            icon="MessageSquareIcon"
            @click="openInNewTab(data.item.urlWhatsApp)"
          />

          <feather-icon
            v-if="canShow"
            class="text-success cursor-pointer"
            aria-label="Show details"
            size="18"
            icon="FileTextIcon"
            @click="onShow(data.item.idAgendaPartial)"
          />

          <feather-icon
            v-if="canEdit"
            class="text-primary cursor-pointer"
            aria-label="Edit details"
            size="18"
            icon="EditIcon"
            @click="onEdit(data.item.idAgendaPartial)"
          />

          <feather-icon
            v-if="canDelete"
            class="text-danger cursor-pointer"
            aria-label="Delete details"
            size="18"
            icon="Trash2Icon"
            @click="onDelete(data.item.idAgendaPartial)"
          />
        </div>
      </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle ml-50"></b-spinner>
            <strong>{{ $t("loading") }}...</strong>
          </div>
        </template>
      </b-table>
    </div>

    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
              @change="handlePerPageChange"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.idAgendaPartial"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong> {{ $t("name") }} : {{ item.nombre || "N/A" }}</strong>

            <b-dropdown
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item
                v-if="canShow"
                @click="onShow(item.idAgendaPartial)"
              >
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("show") }}
                  <feather-icon
                    class="text-success mr-25 cursor-pointer"
                    aria-label="Show details"
                    size="18"
                    icon="FileTextIcon"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canEdit"
                @click="onEdit(item.idAgendaPartial)"
              >
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("edit") }}
                  <feather-icon
                    class="text-primary mr-25 cursor-pointer"
                    aria-label="Edit details"
                    size="18"
                    icon="EditIcon"
                  />
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canDelete"
                @click="onDelete(item.idAgendaPartial)"
              >
                <div class="d-flex align-items-center justify-content-between">
                  {{ $t("delete") }}
                  <feather-icon
                    class="text-danger cursor-pointer"
                    aria-label="Delete details"
                    size="18"
                    icon="Trash2Icon"
                  />
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <p class="m-0">
            <strong>{{ $t(labelHeader("client")) }}: </strong>
            {{ item.nameClient || "N/A" }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("phone")) }}: </strong>
            {{ formatWhatsAppPhone(item.urlWhatsApp) }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("employee")) }}: </strong>
            {{ item.nameEmployee || "N/A" }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("service")) }}: </strong>
            {{ item.nameService || "N/A" }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("create_date")) }}: </strong>
            {{ formatDateTime(item.dateCreation) }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("appointment_date")) }}: </strong>
            {{ formatDate(item.appointmentDate) }}
          </p>

          <p class="m-0">
            <strong>{{ $t(labelHeader("status")) }}: </strong>
            <div class="w-100 mb-1">
              <v-select
                :value="item.idCatStatus"
                :options="listStatus"
                label="label"
                :reduce="(option) => option.value"
                :clearable="false"
                :filterable="false"
                :disabled="changingStatusId === item.idAgendaPartial"
                @input="changeAgendaPartialStatus(item, $event)"
              >
                <span slot="no-options">{{ $t("sorryOption") }}</span>
              </v-select>
            </div>
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("note")) }}: </strong>
            {{ item.notes || "N/A" }}
          </p>
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading" class="text-center">
          <b-spinner class="align-middle ml-50" variant="primary"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BButton,
  BTable,
  BTooltip,
  BSpinner,
  BFormSelect,
  BFormFile,
  BOverlay,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BRow,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import Filterss from "../components/filters/Filterss.vue";

import {
  allAgendaPartials,
  deleteAgendaPartial,
  createOrEditAgendaPartial,
} from "@core/api/request/partialAgenda";
import { getCatalog } from "@core/api/request/catalogs";

import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { canAccess } from "@/security/permissions/permissionHelper";

export default {
  components: {
    vSelect,
    BCard,
    BCardHeader,
    BCardTitle,
    BCol,
    BButton,
    BTable,
    BTooltip,
    BSpinner,
    BFormSelect,
    BFormFile,
    BOverlay,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BRow,
    Filterss,
  },
  directives: {
    "b-tooltip": BTooltip,
    Ripple,
  },
  data: () => ({
    model: "agendaPartial",
    companyGuid: null,
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      {
        label: "client",
        key: "nameClient",
        sortable: true,
        thClass: "agenda-col-client",
        tdClass: "agenda-col-client",
      },
      {
        label: "phone",
        key: "urlWhatsApp",
        sortable: true,
        thClass: "agenda-col-phone",
        tdClass: "agenda-col-phone",
      },
      {
        label: "employee",
        key: "nameEmployee",
        sortable: true,
        thClass: "agenda-col-employee",
        tdClass: "agenda-col-employee",
      },
      {
        label: "service",
        key: "nameService",
        sortable: true,
        thClass: "agenda-col-service",
        tdClass: "agenda-col-service",
      },
      {
        label: "create_date",
        key: "dateCreation",
        sortable: false,
        thClass: "agenda-col-created",
        tdClass: "agenda-col-created",
      },
      {
        label: "appointment_date",
        key: "appointmentDate",
        sortable: false,
        thClass: "agenda-col-appointment",
        tdClass: "agenda-col-appointment",
      },
      {
        label: "status",
        key: "idCatStatus",
        sortable: false,
        thClass: "agenda-col-status",
        tdClass: "agenda-col-status",
      },
      {
        label: "note",
        key: "notes",
        sortable: false,
        thClass: "agenda-col-note",
        tdClass: "agenda-col-note",
      },
      {
        label: "action",
        key: "actions",
        sortable: false,
        thClass: "agenda-col-actions",
        tdClass: "agenda-col-actions",
      },
    ],

    fildsToFilters: [
      {
        name: "name",
        title: "name",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
    listStatus: [],
    changingStatusId: null,
    refreshing: false,
    refreshIntervalId: null,
    refreshIntervalMilliseconds: 15000,
  }),

  computed: {
    canCreate() {
      return canAccess("Agenda Parcial", "creation");
    },
    canShow() {
      return canAccess("Agenda Parcial", "reading");
    },
    canEdit() {
      return canAccess("Agenda Parcial", "edition");
    },
    canDelete() {
      return canAccess("Agenda Parcial", "elimination");
    },
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.hasNextPage = true;
      this.currentPage = 1;
      this.items = [];
      this.loadData();
    },
  },
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.loadData();
  },
  async mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
    this.startAutoRefresh();
  },
  beforeDestroy() {
    this.stopAutoRefresh();
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const params = this.chargeParams();
        const arrParamStatus = getParams([
          `itemsPage,1`,
          `itemsRows,999`,
          "guidCatalog,8b8dd8dc-9665-4483-9609-6e9d1218f5ea",
        ]);
        const [schoolsResp, statusResp] = await Promise.all([
          allAgendaPartials(params),
          getCatalog(arrParamStatus),
        ]);

        // Procesamos agenda parciales
        const agendaPartials = _.get(schoolsResp, "data");
        this.items = agendaPartials?.items || [];
        this.totalRows = agendaPartials?.totalRows || 0;
        this.hasNextPage =
          agendaPartials?.currentPage < agendaPartials?.totalPages || 0;

        const items = _.get(statusResp, "data.listOfItems.items", []);

        this.listStatus = items.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },
    async refreshAgendaPartials(isManual = false) {
      if (
        this.loading ||
        this.refreshing ||
        this.changingStatusId ||
        !this.companyGuid
      ) {
        return;
      }

      this.refreshing = true;
      try {
        const hasAccumulatedMobilePages = this.items.length > this.perPage;
        const page = hasAccumulatedMobilePages ? 1 : this.currentPage;
        const rows = hasAccumulatedMobilePages
          ? this.items.length
          : this.perPage;
        const response = await allAgendaPartials(this.chargeParams(page, rows));
        const agendaPartials = _.get(response, "data");

        this.items = agendaPartials?.items || [];
        this.totalRows = agendaPartials?.totalRows || 0;
        this.hasNextPage =
          agendaPartials?.currentPage < agendaPartials?.totalPages || false;
      } catch (error) {
        if (isManual) {
          this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        } else {
          console.error("Error refreshing agenda partials", error.message);
        }
      } finally {
        this.refreshing = false;
      }
    },
    startAutoRefresh() {
      this.stopAutoRefresh();
      this.refreshIntervalId = window.setInterval(() => {
        this.refreshAgendaPartials();
      }, this.refreshIntervalMilliseconds);
    },
    stopAutoRefresh() {
      if (!this.refreshIntervalId) return;

      window.clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    },
    async loadAgendaPartialsInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const params = this.chargeParams();
        allAgendaPartials(params)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              // Agregar nuevos elementos sin sobreescribir los existentes
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            // Verificar si hay más páginas
            this.hasNextPage = data?.currentPage < data?.totalPages || false;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.error("Error loading agenda partials infinitely", error);
          });
      } catch (error) {
        console.error("Error loading data", error.message);
      }
    },

    formatDate(date) {
      if (!date) return "N/A";

      const parsedDate = new Date(date);

      if (isNaN(parsedDate)) return "N/A";

      return parsedDate.toLocaleDateString(this.dateLocale(), {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },

    formatDateTime(date) {
      if (!date) return "N/A";

      const dateValue = String(date).trim();
      const hasTimeZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(dateValue);
      const parsedDate = new Date(hasTimeZone ? dateValue : `${dateValue}Z`);

      if (isNaN(parsedDate)) return "N/A";

      return parsedDate.toLocaleString(this.dateLocale(), {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    dateLocale() {
      return String(this.$i18n.locale).toLowerCase().startsWith("en")
        ? "en-US"
        : "es-ES";
    },

    formatWhatsAppPhone(urlWhatsApp) {
      if (!urlWhatsApp) return "N/A";

      const value = String(urlWhatsApp).trim();
      const phoneMatch =
        value.match(/wa\.me\/(\+?\d+)/i) ||
        value.match(/[?&]phone=(\+?\d+)/i);
      const phone = phoneMatch ? phoneMatch[1] : value;

      if (!phoneMatch && !/^\+?[\d\s().-]+$/.test(phone)) return "N/A";

      const digits = phone.replace(/\D/g, "");
      return digits || "N/A";
    },

    async changeAgendaPartialStatus(item, newStatus) {
      if (
        !item?.idAgendaPartial ||
        !newStatus ||
        item.idCatStatus === newStatus
      ) {
        return;
      }

      const previousStatus = item.idCatStatus;
      const selectedStatus = this.listStatus.find(
        (status) => status.value === newStatus,
      );
      this.changingStatusId = item.idAgendaPartial;

      try {
        const confirmation = await this.$swal({
          title: this.$t(this.label("statusChange.confirmTitle")),
          text: this.$t(this.label("statusChange.confirmText"), {
            status: selectedStatus?.label || newStatus,
          }),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t(
            this.label("statusChange.confirmButton"),
          ),
          cancelButtonText: this.$t(
            this.label("statusChange.cancelButton"),
          ),
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });

        if (!confirmation.value) return;

        const body = {
          guidCompany: item.guidCompany || this.companyGuid,
          idClient: item.idClient || null,
          idEmployee: item.idEmployee || null,
          idService: item.idService || null,
          notes: item.notes || "",
          idCatStatus: newStatus,
          urlWhatsApp: item.urlWhatsApp || "",
          idAgendaPartial: item.idAgendaPartial,
          appointmentDate: item.appointmentDate || null,
        };

        await createOrEditAgendaPartial(body, item.idAgendaPartial);
        item.idCatStatus = newStatus;
        this.alertToast(
          "success",
          this.$t("Alert"),
          this.$t("updateRecord"),
          "CheckIcon",
        );
      } catch (error) {
        item.idCatStatus = previousStatus;
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      } finally {
        this.changingStatusId = null;
      }
    },

    label(field) {
      return `pages.agendaPartial.table.${field}`;
    },
    labelHeader(field) {
      return `pages.agendaPartial.table.tableHeader.${field}`;
    },
    chargeParams(page = this.currentPage, rows = this.perPage) {
      const arrParams = [];
      arrParams.push(`page,${page}`);
      arrParams.push(`rows,${rows}`);
      arrParams.push(`guidCompany,${this.companyGuid}`);

      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }
      return getParams(arrParams);
    },
    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadAgendaPartialsInfinity();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },
    handlePerPageChange() {
      this.loadData();
    },
    validateFilters(filters) {
      // Validar nombre (no debe ser vacío ni contener solo espacios)
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }
      return true;
    },
    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadData();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },
    resetFilters() {
      this.appliedFilters = {};

      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
    openInNewTab(url) {
      if (!url) {
        this.alertToast(
          "danger",
          "Error",
          "Link de whatsapp no disponible",
          "AlertTriangleIcon",
        );

        return;
      }

      window.open(url, "_blank", "noopener,noreferrer");
    },
    onCreate() {
      if (!this.canCreate) return;
      this.$router.push({
        name: "agendaPartialCreate",
        params: { option: 1 },
      });
    },
    onShow(idAgendaPartial) {
      if (!this.canShow) return;
      this.$router.push({
        name: "agendaPartialEdit",
        params: { option: 2, idAgendaPartial },
      });
    },
    onEdit(idAgendaPartial) {
      if (!this.canEdit) return;
      this.$router.push({
        name: "agendaPartialEdit",
        params: { option: 3, idAgendaPartial },
      });
    },
    onDelete(idAgendaPartial) {
      if (!this.canDelete) return;
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          showLoading();
          deleteAgendaPartial(idAgendaPartial)
            .then((resp) => {
              stopLoading();
              this.$swal({
                icon: "success",
                title: this.$t("Deleted"),
                text: this.$t("beenDeleted"),
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.loadData();
            })
            .catch((error) => {
              console.log("error", error.message);
              stopLoading();
              this.alertToast(
                "danger",
                this.$t("codeAlert"),
                error.message,
                "AlertTriangleIcon",
              );
            });
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },
    onInfo() {},
    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
#page-agenda-partial {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.agenda-partial-table-shell {
  width: 100%;
  max-width: 100%;
  min-width: 0;

  > .table-responsive {
    display: block;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-color: #b9b7c7 #f3f2f7;

    &::-webkit-scrollbar {
      height: 10px;
    }

    &::-webkit-scrollbar-track {
      background: #f3f2f7;
      border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb {
      background: #b9b7c7;
      border: 2px solid #f3f2f7;
      border-radius: 999px;
    }
  }
}

.agenda-partial-data-table {
  min-width: 1900px;
  margin-bottom: 0;

  thead th {
    vertical-align: middle;
    padding: 1rem 0.9rem;
    line-height: 1.25;
    white-space: nowrap;
  }

  tbody td {
    vertical-align: middle;
    padding: 1rem 0.9rem;
    line-height: 1.45;
    word-break: normal;
    overflow-wrap: break-word;
  }

  tbody tr {
    transition: background-color 0.18s ease;

    &:hover {
      background-color: rgba(115, 103, 240, 0.035);
    }
  }

  .agenda-col-client {
    min-width: 190px;
  }

  .agenda-col-phone {
    min-width: 150px;
    white-space: nowrap;
  }

  .agenda-col-employee {
    min-width: 190px;
  }

  .agenda-col-service {
    min-width: 270px;
  }

  .agenda-col-created {
    min-width: 195px;
    white-space: nowrap;
  }

  .agenda-col-appointment {
    min-width: 165px;
    white-space: nowrap;
  }

  .agenda-col-status {
    min-width: 195px;
  }

  .agenda-col-note {
    min-width: 430px;
    max-width: 430px;
  }

  .agenda-col-actions {
    min-width: 125px;
    width: 125px;
    position: sticky;
    right: 0;
    z-index: 2;
    background-color: #fff;
    text-align: center;
    box-shadow: -8px 0 14px -14px rgba(34, 41, 47, 0.55);
  }

  thead .agenda-col-actions {
    z-index: 3;
    background-color: #f3f2f7;
  }

  tbody tr:hover .agenda-col-actions {
    background-color: #fbfaff;
  }
}

.agenda-partial-status-select {
  min-width: 165px;

  .vs__dropdown-toggle {
    min-height: 42px;
  }

  .vs__selected {
    white-space: nowrap;
  }
}

.agenda-partial-note {
  line-height: 1.5;
}

.agenda-partial-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  white-space: nowrap;
}

.per-page-selector {
  width: 90px;
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
